<template>
    <div class="tab-label" :class="{ focus:title == selectedTitle }"
        v-for="title in tabTitles"
        :key="title"
        @click="selectedTitle = title; addHash(selectedTitle)"
    >
        {{ title }}
    </div>
    <slot />

</template>

<script>
import { ref, provide, watch } from 'vue'
import { useRoute } from 'vue-router';

export default {
    
    setup( props, { slots }) {
        const tabTitles = ref(slots.default().map((tab) => tab.props.title))
        const selectedTitle = ref(tabTitles.value[0])
        const route = useRoute();

        if (window.location.hash != "" && route.hash !="#banner") {
            let hash = decodeURIComponent(window.location.hash.split("#")[1]);
            selectedTitle.value = hash;
        }
        
        watch(route,()=>{
            if (route.hash != "" && route.hash !="#banner") {
                let hash = decodeURIComponent(route.hash.split("#")[1]);
                selectedTitle.value = hash;
            }else {
                selectedTitle.value = tabTitles.value[0];
            }
        })

        provide('selectedTitle', selectedTitle)

        let addHash = (selectedTitle) => {
            location.hash = selectedTitle;
        }

        return {
            selectedTitle,
            tabTitles,
            addHash
        }
    }
}
</script>

<style src="@/assets/css/tab.css" scoped> </style>